import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

Vue.use(VueRouter)
const Layout = () => import('../components/layout/ViewApp')
const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/pages/Login.vue')
    },
    {
        path: '*',
        component: () => import('@/views/pages/Page404'),
    },
    {
        path: '/page500',
        component: () => import('@/views/pages/Page500'),
    },
    {
        path: '/error400',
        component: () => import('@/views/pages/Page400'),
    },
    {
        path: '/page403',
        component: () => import('@/views/pages/Page403'),
    },
    {
        path: '/error423',
        component: () => import('@/views/pages/Page423'),
    },
    {
        path: '/networkError',
        component: () => import('../views/pages/PageNetError'),
    },



    {
        path: '/home',
        name: 'Home',
        component: Layout,
        children: [
            {
                name: 'Dashboard',
                path: '/',
                component: () => import('../views/pages/Home'),
                meta: {
                    auth: true // A protected route
                },
            },

            {
                name: 'PCBsi',
                path: '/pCBsi/:id',
                component: () => import('../views/define/account/PageCallbackBsi'),
                props: true,

            },
            {
                name: 'PCParsian',
                path: '/pCParsian/:id',
                component: () => import('../views/define/account/PageCallbackParsian.vue'),
                props: true,

            },
            {
                name: 'pageReport',
                path: 'pageReport',
                component: () => import('../views/define/account/PageReport.vue'),
                props: true,

            },
            {
                name: 'profile',
                path: '/profile',
                component: () => import('../views/define/profile/PageEdit.vue'),
                meta: {
                    auth: true,
                }
            },

            {
                name: 'Building',
                path: '/building',
                component: () => import('../views/define/building/PageList.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['buildingPage']
                },
            },
            {
                name: 'unit',
                path: '/unit',
                component: () => import('../views/define/unit/UnitList.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['unitPage']
                },
            },

            {
                name: 'Role',
                path: '/role',
                component: () => import('../views/define/role/PageList.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['rolePage']
                },
            },
            {
                name: 'editRole',
                path: '/editRole',
                component: () => import('../views/define/role/PageEdit'),
                props: true,
                meta: {
                    auth: true, // A protected route
                    permissions: ['rolePage']
                },
            },

            {
                name: 'User',
                path: '/user',
                component: () => import('../views/define/user/PageList.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['userPage']
                },
            },
            {
                name: 'Establishment',
                path: '/establishment',
                component: () => import('../views/define/establishment/PageList.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['establishmentPage']
                },
            },
            {
                name: 'information',
                path: '/information',
                component: () => import('../views/define/establishment/PageInformation.vue'),
                props: true,
                meta: {
                    auth: true, // A protected route
                    permissions: ['furtherInformation']
                },
            },
            {
                name: 'guest',
                path: '/guest',
                component: () => import('../views/define/guest/PageList'),
                props: true,
                meta: {
                    auth: true, // A protected route
                    permissions: ['guestPage']
                },
            },
            {
                name: 'User',
                path: '/disabledUsers',
                component: () => import('../views/define/inactiveUser/PageList.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['disabledUsers']
                },
            },
                {
                name: 'Manager',
                path: '/manager',
                component: () => import('../views/define/manager/PageList.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['managerPage']
                },
            },
            {
                name: 'dailyAccountSms',
                path: '/dailyAccountSms',
                component: () => import('../views/define/templateDailyAccountSms/PageList.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['dailyAccountSmsPage']
                },
            },
            {
                name: 'chargingAlarmSetting',
                path: '/chargingAlarmSetting',
                component: () => import('../views/define/chargingAlarmSetting/PageList.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['chargingAlarmSettingPage']
                },
            },
    {
                name: 'Management',
                path: '/management',
                component: () => import('../views/define/userManagement/PageList.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['managementUser']
                },
            },
            {
                name: 'Message',
                path: '/message',
                component: () => import('../views/define/message/PageList.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['messagePage']
                },
            },
            {
                name: 'MessageReceive',
                path: '/messageReceive',
                component: () => import('../views/define/message/ReceivePage.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['messagePage']
                },
            },
            {
                name: 'detailMsg',
                path: '/detailMsg',
                component: () => import('../views/define/message/DetailList.vue'),
                props: true,
                meta: {
                    auth: true, // A protected route
                    permissions: ['messagePage']
                },
            },
            {
                name: 'accountOld',
                path: '/accountOld',
                component: () => import('../views/define/account/PageListOld.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['accountOld']
                },
            },
            {
                name: 'Account',
                path: '/account',
                component: () => import('../views/define/account/PageList.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['accountPage']
                },
            },
            {
                name: 'DetailAccount',
                path: '/DetailAccount',
                component: () => import('../views/define/account/PageDetails.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['accountPage']
                },
            },
            {
                name: 'payment',
                path: '/payment',
                component: () => import('../views/define/account/Payment.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['accountPage']
                },
            },
            {
                name: 'verify',
                path: '/verify/:id',
                component: () => import('../views/define/account/PageCallback.vue'),
                props: true,

            },

            {
                name: 'SmsExcel',
                path: '/smsExcel',
                component: () => import('../views/define/smsByExcel/PageEdit.vue'),
                meta: {
                    auth: true, // A protected route
                    permissions: ['userPage']
                },
            },

            {
                name: 'SeeMsg',
                path: '/seeMsg/:model',
                component: () => import('../views/define/message/SeeMsg.vue'),

            },
            {
                name: 'slider',
                path: '/slider',
                component: () => import('../views/define/slideShow/PageList'),

            },
            {
                name: 'mainGroup',
                path: '/mainGroup',
                component: () => import('../views/define/mainGroup/PageList'),

            },
            {
                name: 'mainJob',
                path: '/mainJob',
                component: () => import('../views/define/mainJob/PageList'),

            },
            {
                name: 'mainJobEdit',
                path: '/mainJobEdit',
                component: () => import('../views/define/mainJob/PageEdit'),

            },
            {
                name: 'discount',
                path: '/discount',
                component: () => import('../views/define/discount/PageList'),

            },
            {
                name: 'request',
                path: '/request',
                component: () => import('../views/define/requestUser/PageList'),

            },
            {
                name: 'Inquiry',
                path: '/inquiry',
                component: () => import('../views/define/inquiry/PageList.vue'),

            },
            {
                name: 'kavehNegar',
                path: '/kavehNegar',
                component: () => import('../views/define/kavehNegar/PageList.vue'),

            },
            {
                name: 'templateSmsManager',
                path: '/templateSmsManager',
                component: () => import('../views/define/templateSmsManager/PageList.vue'),

            },
            {
                name: 'confirmTemplateSms',
                path: '/confirmTemplateSms',
                component: () => import('../views/define/requestConfirmTemplate/PageList.vue'),

            },
            {
                name: 'subscription',
                path: '/subscription',
                component: () => import('../views/define/subscriptionSetting/PageList.vue'),

            },
            {
                name: 'ForgetPass',
                path: '/forgetPass',
                component: () => import('../views/define/profile/ForgetPass.vue'),

            },
           {
                name: 'reportPyment',
                path: '/reportPyment',
                component: () => import('../views/reporting/ReportOfPayment.vue'),

            },
            {
                name: 'smsReport',
                path: '/smsReport',
                component: () => import('../views/reporting/SmsManager/smsManagerReport.vue'),

            },
            {
                name: 'dailyAccountReport',
                path: '/dailyAccountReport',
                component: () => import('../views/reporting/DailyAccountReport/DailyAccountReport.vue'),

            },
            {
                name: 'remainingReport',
                path: '/remainingReport',
                component: () => import('../views/reporting/remainingReport/Page.vue'),

            },
            {
                name: 'detailsUintReport',
                path: '/detailsUintReport',
                component: () => import('../views/reporting/detailsUnitReport/Page.vue'),

            },
            {
                name: 'smsManager',
                path: '/smsManager',
                component: () => import('../views/define/SMSManager/PageList.vue'),

            },
            {
                name: 'smsByManager',
                path: '/smsByManager',
                component: () => import('../views/define/smsByManager/Page.vue'),

            },

         {
                name: 'reportDebt',
                path: '/reportDebt',
                component: () => import('../views/reporting/debt/ReportDebt.vue'),

            },
            {
                name: 'unitEditRequest',
                path: '/unitEditRequest',
                component: () => import('../views/define/unitEditRequest/UnitEditRequest.vue'),

            },


        ]
    },

]

const router = new VueRouter({
    routes,
    mode: 'history',
    base: process.env.BASE_URL,

})

export default router
router.beforeEach((to, from, next) => {

    if (to.path === '' || to.path==='/'){
        localStorage.clear();
        next({ name: 'Login' })
    }

    var token = ""
    try {
        const state = JSON.parse(localStorage.getItem('vuex-state'));
        token = state.token;
    } catch (e) {
        token = "";
    }

    if (to.meta.auth && !token) {
        next('/login')
    } else {

                if (to.meta.permissions && to.meta.permissions.length > 0) {
            let isAllowed = store.state.permissions.some(p => to.meta.permissions.includes(p))

            if (!isAllowed) return next('/')
        }

        next()
    }
})
